import React from "react";
import Header from "./Header";
import Footer from "./Footer";


const Layout = ({ children, styleId }) => (
  <React.Fragment>
    <Header />
    <main id={styleId}>{children}</main>
    <Footer />
  </React.Fragment>

);

export default Layout;
